import russianMessages from './ru_RU';

const translationMessages = {
  ru: russianMessages,
};

export default translationMessages;
